"use strict";
//types for payment form integration
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardType = exports.TokenType = exports.PaymentSource = exports.PaymentType = exports.PaymentTransactionType = exports.PaymentTokenType = void 0;
var PaymentTokenType;
(function (PaymentTokenType) {
    PaymentTokenType["STT"] = "stt";
    PaymentTokenType["OTT"] = "ott";
})(PaymentTokenType = exports.PaymentTokenType || (exports.PaymentTokenType = {}));
var PaymentTransactionType;
(function (PaymentTransactionType) {
    PaymentTransactionType["PAYMENT"] = "payment";
    PaymentTransactionType["AUTHORISATION"] = "authorisation";
    PaymentTransactionType["REFUND"] = "refund";
})(PaymentTransactionType = exports.PaymentTransactionType || (exports.PaymentTransactionType = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["BANKACCOUNT"] = "bankaccount";
    PaymentType["CARD"] = "card";
    PaymentType["CUSTOM_CHECKOUT"] = "customcheckout";
    PaymentType["SAVED_CARD"] = "savedcard";
    PaymentType["SAVED_DIRECT_DEBIT"] = "saveddirectdebit";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var PaymentSource;
(function (PaymentSource) {
    PaymentSource["IVR"] = "ivr";
    PaymentSource["MY_ACCOUNT"] = "my_account";
    PaymentSource["WEBSITE"] = "website";
})(PaymentSource = exports.PaymentSource || (exports.PaymentSource = {}));
var TokenType;
(function (TokenType) {
    TokenType["CARD"] = "CARD";
    TokenType["OTT"] = "OTT";
    TokenType["STT"] = "STT";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
var CreditCardType;
(function (CreditCardType) {
    CreditCardType["AMEX"] = "AMEX";
    CreditCardType["MASTERCARD"] = "MASTERCARD";
    CreditCardType["VISA"] = "VISA";
})(CreditCardType = exports.CreditCardType || (exports.CreditCardType = {}));
//# sourceMappingURL=paymentForm.js.map